/**
 * 顧問固定櫃（全國不動產板橋加盟店）
 */
import { SovereignCabinet } from '../../core/cabinet-base.js';

class ConsultantCabinet extends SovereignCabinet {
    constructor() {
        super();
        this.loadAssets('/js/cabinets/consultant');
    }
}

customElements.define('consultant-cabinet', ConsultantCabinet);

function dock() {
    if (!window.appCore) return;
    const container = document.getElementById('socket-consultant');
    if (!container) return;
    const instance = document.createElement('consultant-cabinet');
    container.innerHTML = '';
    container.appendChild(instance);
    window.appCore.registerCabinet('consultant', instance);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dock);
} else {
    dock();
}
